import * as yup from "yup";
export var makeListBuilderSchema = function(listItem) {
    return yup.array().of(yup.object().test({
        test: function test(value) {
            var _this = this;
            var _this_path_match;
            // allow last row to be empty
            if ((this.parent.length > 1 || !listItem.tests.some(function(test) {
                return test.OPTIONS.name === 'required';
            }) && this.parent.length === 1) && +((_this_path_match = this.path.match(/\[(\d+)\]/)) === null || _this_path_match === void 0 ? void 0 : _this_path_match[1]) === this.parent.length - 1 && !Object.values(value).some(Boolean)) {
                return true;
            }
            // manually validate so we can set paths correctly
            try {
                return !!listItem.validateSync(value, {
                    abortEarly: false
                });
            } catch (e) {
                throw new yup.ValidationError(e.inner.map(function(err) {
                    return _this.createError({
                        message: err.message,
                        path: "".concat(_this.path, ".").concat(err.path)
                    });
                }));
            }
        }
    })).min(listItem.tests.some(function(test) {
        return test.OPTIONS.name === 'required';
    }) ? 1 : 0);
};

//# sourceMappingURL=makeListBuilderSchema.js.map